import React, { useState } from 'react';
import { HintsProps } from './types';
import style from './style.module.scss';
import cx from 'classnames';
import { DefaultButton, LinkButton } from '@magoosh/lib/button';
import { BulbIcon } from './icons';
import Hints from './hints';
import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';

export const HintsWrapper: React.FC<HintsProps> = (props) => {

  const markHintsAsSkipped = () => {
    return fetch(paths.api.markings(), {
      body: JSON.stringify({
        markableId: props.promptId,
        markableType: 'Prompt',
        name: 'hints_skipped'
      }),
      method: 'POST'
    });
  };

  const markHintsAsViewed = () => {
    return fetch(paths.api.markings(), {
      body: JSON.stringify({
        markableId: props.promptId,
        markableType: 'Prompt',
        name: 'hints_viewed'
      }),
      method: 'POST'
    });
  };

  const skipToAnswer = () => {
    markHintsAsSkipped().then((resp) => window.location.assign(props.skipToAnswerUrl));
  };

  const tryAgain = () => {
    markHintsAsViewed().then((resp) => window.location.assign(props.tryAgainUrl));
  };

  return (
    <div className={cx(style.hintsWrapper, props.displayHints ? style.opened : style.closed, 'u-padding-V-s')}>
      <div className={style.header}>
        <div>
          <BulbIcon fill={props.displayHints ? style.systemBlack : style.systemWhite} />
          <h4 className="u-margin-H-s u-margin-V-n">
            <strong>
              {!props.displayHints
                ? 'Do you want to see a hint and try this question again?'
                : 'Select a new answer with help from a hint.'}
            </strong>
          </h4>
        </div>
        {!props.displayHints && (
          <div>
            <DefaultButton className="u-margin-H-m" onClick={tryAgain}>
              Try Again
            </DefaultButton>
            <LinkButton className={style.skipToAnswer} onClick={skipToAnswer}>
              <strong>Skip to Answer</strong>
            </LinkButton>
          </div>
        )}
      </div>

      {props.displayHints && (
        <div className={style.accordion}>
          <Hints hints={props.hints} />
        </div>
      )}
    </div>
  );
};

export default HintsWrapper;
